import { Component } from '@angular/core';

/**
 * @summary Task detail Private notes tab — placeholder until feature ships.
 * @selector proffeo-task-details-private-notes-tab
 */
@Component({
  selector: 'proffeo-task-details-private-notes-tab',
  templateUrl: './task-details-private-notes-tab.component.html'
})
export class TaskDetailsPrivateNotesTabComponent {}
